module.exports = __webpack_public_path__ + "img/monitor_logo_large_light.4d4c1fbf.svg";